/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface WithConfirmTemplate
 */
export interface WithConfirmTemplateOptional {
  /**
   *
   * @type {string}
   * @memberof WithConfirmTemplate
   */
  confirmTemplate?: string;
}

export interface WithConfirmTemplate extends WithConfirmTemplateOptional {
  /**
   *
   * @type {string}
   * @memberof WithConfirmTemplate
   */
  confirmTemplate?: string;
}

export interface WithConfirmTemplateTrackedI {
  /**
   *
   * @type {string}
   * @memberof WithConfirmTemplate
   */
  confirmTemplate?: string;
  confirmTemplateIsSet: boolean;
}

transformDatesMap.set(
  "WithConfirmTemplate",
  function (model: WithConfirmTemplate) {},
);

export type WithConfirmTemplateMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  confirmTemplate: PropertyMeta<MetaTypeBase<string>>;
}>;

export var WithConfirmTemplateMeta: WithConfirmTemplateMetaI =
  {} as WithConfirmTemplateMetaI;
WithConfirmTemplateMeta = typeMeta("WithConfirmTemplate", {
  confirmTemplate: propertyMeta(
    "confirmTemplate",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = WithConfirmTemplateMeta;

registerMeta(() => {});

export class WithConfirmTemplateTracked implements WithConfirmTemplateTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  confirmTemplate__I?: string = undefined;
  confirmTemplateIsSet: boolean = false;
  set confirmTemplate(v: undefined | string) {
    if (v !== undefined) {
      this.confirmTemplate__I = v;
      this.confirmTemplateIsSet = true;
    } else {
      this.confirmTemplate__I = v || undefined;
      this.confirmTemplateIsSet = false;
    }
    this.changeTracker = true;
  }
  get confirmTemplate() {
    return this.confirmTemplate__I;
  }
  constructor(config?: WithConfirmTemplateOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: WithConfirmTemplateOptional,
    options?: AssignOptions,
  ): WithConfirmTemplateTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.confirmTemplate &&
      this.confirmTemplateApplyFilter(optionsRequired.filter)
    ) {
      this.confirmTemplate = config.confirmTemplate;
      if (optionsRequired.unassign) this.confirmTemplateIsSet = false;
      else this.confirmTemplateIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): WithConfirmTemplateTrackedI {
    const cloned = {} as WithConfirmTemplateTrackedI;
    if (
      this.confirmTemplateIsSetDeep() &&
      this.confirmTemplateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.confirmTemplateIsSet = true;
      cloned.confirmTemplate = this.confirmTemplate;
    } else {
      //cloned.confirmTemplateIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): WithConfirmTemplateTrackedI {
    if (!this.confirmTemplateApplyFilter(filter))
      this.confirmTemplateIsSet = false;

    return this;
  }
  confirmTemplateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      WithConfirmTemplateMeta.confirmTemplate,
      WithConfirmTemplateMeta,
      this.confirmTemplate,
      this,
    );
  }
  confirmTemplateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.confirmTemplateIsSet && this.confirmTemplateApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.confirmTemplateIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
